import { parseDisplayUserName } from "../utils/userName";

const identifyUser = (gainsightUserData) => {
  const {
    puaId,
    fullDisplayName,
    email,
    applicationCode,
    affiliationId,
    affiliationName,
    specialty,
    role,
    trafficSource,
    isAdminUser,
    isAnalyticsUser,
    isDynaAIUser,
    customFieldOne,
    customFieldTwo,
    customFieldThree,
    customFieldFour,
    customFieldFive
  } = gainsightUserData;
  const { firstName, lastName } = parseDisplayUserName(fullDisplayName);
  const { authMethodPrimary, authMethodSecondary, ehrVendor } =
    trafficSource || {};

  let id = "";
  if (puaId) {
    id = puaId;
  } else {
    id = `${affiliationId ? `${affiliationId}_` : ""}anon_${applicationCode}`;
  }

  const isDynaAIEnabled = isDynaAIUser
    ? !(
        window?.localStorage["rag-hide"] &&
        window?.localStorage["rag-hide"]?.includes(id)
      )
    : undefined;

  window?.aptrinsic(
    "identify",
    {
      id,
      firstName,
      lastName,
      fullName: fullDisplayName,
      email: email?.toLowerCase(),
      medicalSpecialty: specialty,
      medicalRole: role,
      authMethodPrimary,
      authMethodSecondary,
      ehrVendor,
      isAdminUser,
      isAnalyticsUser,
      isDynaAIEnabled,
      customFieldOne,
      customFieldTwo,
      customFieldThree,
      customFieldFour,
      customFieldFive
    },
    {
      id: affiliationId || `openweb_${applicationCode}`,
      name: affiliationName
    }
  );
  window?.aptrinsic("set", "globalContext", { applicationCode });
};

export default identifyUser;
